import { render, staticRenderFns } from "./mcfenxiall.vue?vue&type=template&id=00d3501c&scoped=true"
import script from "./mcfenxiall.vue?vue&type=script&lang=js"
export * from "./mcfenxiall.vue?vue&type=script&lang=js"
import style0 from "./mcfenxiall.vue?vue&type=style&index=0&id=00d3501c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3501c",
  null
  
)

export default component.exports